// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ux_carousel__OSIcD"};